import React from "react";
import { withStyles } from "@material-ui/core/styles";

import {
    Datagrid,
    DateField,
    List,
    ReferenceField,
    ShowButton,
    EditButton,
    TextField,
    BooleanField,
    NumberField,
    TextInput,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
    title: {
        maxWidth: "20em",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
});

// const filters = [<TextInput label="Search" source="code" alwaysOn />];

export const IsolatesAntibioticsInterpretationsList = withStyles(styles)(
    ({ classes, ...props }) => (
        <List
            {...props}
            //  filters={filters}
            // actions={<MyListActions />}
            pagination={<MyListPagination />}
            perPage={100}
        >
            <Datagrid>
                <ReferenceField
                    label="External Isolate"
                    source="id_external_isolate"
                    reference="external_isolates"
                    link="show"
                >
                    <TextField source="code" />
                </ReferenceField>

                <ReferenceField
                    label="Isolate"
                    source="id_isolate"
                    reference="isolates"
                    link="show"
                >
                    <TextField source="code" />
                </ReferenceField>

                <ReferenceField
                    label="Antibiotic"
                    source="id_antibiotic"
                    reference="antibiotics"
                    link="show"
                >
                    <TextField source="name" />
                </ReferenceField>

                <TextField label="Mic operator" source="mic_operator" />
                <NumberField label="Mic value " source="mic_value" />
                <NumberField label="Mic interpretation " source="mic_interpetation" />

                <DateField label="Interpretation date" source="interpretation_date" />
                <BooleanField label="Is External Isolate?" source="is_external_isolate" />

                <TextField label="Notes" source="notes" />

                <DateField
                    source="createdAt"
                    locales="es-UY"
                    options={{ timeZone: "UTC" }}
                    showTime
                />
                <DateField
                    source="updatedAt"
                    locales="es-UY"
                    options={{ timeZone: "UTC" }}
                    showTime
                />
                {/* <EditButton />
        <ShowButton />*/}
            </Datagrid>
        </List>
    )
);
